var _ellipse, _ellipse2, _ellipse3, _g, _path, _path2, _g2, _path3, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _path8, _g6, _path9, _g7, _path10, _g8, _path11, _g9, _path12, _g10, _g11, _g12, _g13, _path13, _g14, _path14, _path15, _g15, _path16, _path17, _g16, _path18, _g17, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _g22, _path22, _g23, _path23, _g24, _path24, _g25, _g26, _path25, _g27, _g28, _g29, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJudgment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 196,
    viewBox: "0 0 195 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.4021,
    cy: 97.5772,
    rx: 96.9021,
    ry: 97.0772,
    stroke: "#04D9B5",
    strokeOpacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.402,
    cy: 97.5771,
    rx: 77.2977,
    ry: 77.4374,
    stroke: "#04D9B5",
    strokeOpacity: 0.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.4021,
    cy: 97.5773,
    rx: 57.7293,
    ry: 57.8336,
    stroke: "#04D9B5",
    strokeOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.2674 135.972C66.2674 135.972 46.9475 88.3954 46.9636 88.4557L53.8027 81.004L69.3501 90.4722L66.2674 135.972Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.2674 135.972C66.2674 135.972 46.9475 88.3954 46.9636 88.4557L53.8027 81.004L69.3501 90.4722L66.2674 135.972Z",
    fill: "url(#paint0_linear_14933_19520)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M66.2674 135.972C66.2674 135.972 46.9475 88.3954 46.9636 88.4557L53.8027 81.004L69.3501 90.4722L66.2674 135.972Z",
    fill: "url(#paint1_linear_14933_19520)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9476 85.707L43.2993 69.7131L50.3753 75.7961L53.3842 81.4232L46.8091 88.8877L29.9476 85.707Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9476 85.707L43.2993 69.7131L50.3753 75.7961L53.3842 81.4232L46.8091 88.8877L29.9476 85.707Z",
    fill: "url(#paint2_linear_14933_19520)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9476 85.707L43.2993 69.7131L50.3753 75.7961L53.3842 81.4232L46.8091 88.8877L29.9476 85.707Z",
    fill: "url(#paint3_linear_14933_19520)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter3_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.974 78.5462L68.444 91.5383L53.2413 81.8122L50.2195 76.1543L64.974 78.5462Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.974 78.5462L68.444 91.5383L53.2413 81.8122L50.2195 76.1543L64.974 78.5462Z",
    fill: "url(#paint4_linear_14933_19520)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.53 69.6709L54.3168 68.3665L65.9127 77.6895L50.7678 75.5298L43.53 69.6709Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.53 69.6709L54.3168 68.3665L65.9127 77.6895L50.7678 75.5298L43.53 69.6709Z",
    fill: "url(#paint5_linear_14933_19520)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter5_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6395 88.9182L34.743 93.8732L61.3838 136.864L65.5798 136.097L46.6395 88.9182Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.6395 88.9182L34.743 93.8732L61.3838 136.864L65.5798 136.097L46.6395 88.9182Z",
    fill: "url(#paint6_linear_14933_19520)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.6395 88.9182L34.743 93.8732L61.3838 136.864L65.5798 136.097L46.6395 88.9182Z",
    fill: "url(#paint7_linear_14933_19520)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter6_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8244 85.3866L28.8292 91.6341L34.8542 93.2744L46.9393 88.3239L29.8244 85.3866Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8244 85.3866L28.8292 91.6341L34.8542 93.2744L46.9393 88.3239L29.8244 85.3866Z",
    fill: "url(#paint8_linear_14933_19520)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter7_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3187 136.876L34.8307 93.8572L28.9248 92.1562L61.3187 136.876Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M61.3187 136.876L34.8307 93.8572L28.9248 92.1562L61.3187 136.876Z",
    fill: "url(#paint9_linear_14933_19520)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter8_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8027 90.372L74.7378 95.8572L65.5798 136.098L68.8027 90.372Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.8027 90.372L74.7378 95.8572L65.5798 136.098L68.8027 90.372Z",
    fill: "url(#paint10_linear_14933_19520)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter9_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4968 80.8853L72.3448 86.4411L74.7442 95.8912L69.0356 90.37L66.4968 80.8853Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M66.4968 80.8853L72.3448 86.4411L74.7442 95.8912L69.0356 90.37L66.4968 80.8853Z",
    fill: "url(#paint11_linear_14933_19520)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter11_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.411 71.0487L131.007 64.3531L121.526 64.3908L128.411 71.0487Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter12_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.931 58.0931L117.753 62.7042L108.285 62.6899L114.931 58.0931Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter13_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.364 63.9655L117.63 62.1628L114.826 57.7423L130.895 54.8992L143.626 54.9857L145.618 56.6834L130.81 63.8435L121.364 63.9655Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.242 70.9822L127.198 81.9052L133.638 86.0799L146.794 84.7109L145.959 70.442L145.827 56.6067L130.924 63.946L128.242 70.9822Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.242 70.9822L127.198 81.9052L133.638 86.0799L146.794 84.7109L145.959 70.442L145.827 56.6067L130.924 63.946L128.242 70.9822Z",
    fill: "url(#paint12_linear_14933_19520)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter15_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.299 62.9664L100.964 68.9615L94.6419 91.0496L101.352 101.94L117.755 87.2104L127.293 82.7969L128.345 71.7883L121.483 64.8559L117.707 63.0204L108.299 62.9664Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.299 62.9664L100.964 68.9615L94.6419 91.0496L101.352 101.94L117.755 87.2104L127.293 82.7969L128.345 71.7883L121.483 64.8559L117.707 63.0204L108.299 62.9664Z",
    fill: "url(#paint13_linear_14933_19520)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.299 62.9664L100.964 68.9615L94.6419 91.0496L101.352 101.94L117.755 87.2104L127.293 82.7969L128.345 71.7883L121.483 64.8559L117.707 63.0204L108.299 62.9664Z",
    fill: "url(#paint14_linear_14933_19520)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter16_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.554 99.9053L133.687 86.5629L127.246 82.3232L117.722 86.8632L101.302 101.928L125.554 99.9053Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M125.554 99.9053L133.687 86.5629L127.246 82.3232L117.722 86.8632L101.302 101.928L125.554 99.9053Z",
    fill: "url(#paint15_linear_14933_19520)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.554 99.9053L133.687 86.5629L127.246 82.3232L117.722 86.8632L101.302 101.928L125.554 99.9053Z",
    fill: "url(#paint16_linear_14933_19520)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter17_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.658 85.2354L138.087 93.4489L125.044 99.6444L133.208 86.5692L146.658 85.2354Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.658 85.2354L138.087 93.4489L125.044 99.6444L133.208 86.5692L146.658 85.2354Z",
    fill: "url(#paint17_linear_14933_19520)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter19_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7878 129.404L78.7124 120.206L76.0882 130.892L83.7891 135.01L85.6311 137.875L86.7878 129.404Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter20_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5317 129.357L95.911 132.78L96.8114 139.829L95.9893 144.159L93.1803 147.093L88.0543 144.877L85.3832 137.799L86.5317 129.357Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5317 129.357L95.911 132.78L96.8114 139.829L95.9893 144.159L93.1803 147.093L88.0543 144.877L85.3832 137.799L86.5317 129.357Z",
    fill: "url(#paint18_linear_14933_19520)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.252 111.043L78.9743 120.071L86.9372 129.258L90.647 122.47L91.2763 113.825L82.252 111.043Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.252 111.043L78.9743 120.071L86.9372 129.258L90.647 122.47L91.2763 113.825L82.252 111.043Z",
    fill: "url(#paint19_linear_14933_19520)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.0261 128.552L90.4203 122.183L86.7023 129.054L96.0279 132.567L99.0261 128.552Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0261 128.552L90.4203 122.183L86.7023 129.054L96.0279 132.567L99.0261 128.552Z",
    fill: "url(#paint20_linear_14933_19520)"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter23_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.0513 117.951L91.224 113.689L90.5467 122.152L95.0513 117.951Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1451 129.039L95.0496 118.285L90.6544 122.593L99.1451 129.039Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1451 129.039L95.0496 118.285L90.6544 122.593L99.1451 129.039Z",
    fill: "url(#paint21_linear_14933_19520)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter25_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4121 144.53L84.6933 147.785L76.0044 130.548L83.8505 134.61L85.7155 137.458L88.4121 144.53Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4121 144.53L84.6933 147.785L76.0044 130.548L83.8505 134.61L85.7155 137.458L88.4121 144.53Z",
    fill: "url(#paint22_linear_14933_19520)"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter26_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.4349 153.456L93.2268 146.475L88.3152 144.133L92.7726 153.568L95.4349 153.456Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M95.4349 153.456L93.2268 146.475L88.3152 144.133L92.7726 153.568L95.4349 153.456Z",
    fill: "url(#paint23_linear_14933_19520)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter27_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.2923 147.477L92.6654 153.442L88.0468 144.199L84.2923 147.477Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter28_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9968 151.046L95.8111 143.684L93.0708 146.616L95.2721 153.496L96.9968 151.046Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.9968 151.046L95.8111 143.684L93.0708 146.616L95.2721 153.496L96.9968 151.046Z",
    fill: "url(#paint24_linear_14933_19520)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter29_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.9857 128.387L99.4361 136.398L96.8115 139.29L95.9328 132.329L98.9857 128.387Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter30_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8047 137.393L96.8114 139.29L99.2289 136.625L99.8047 137.393Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter31_i_14933_19520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.9137 151.02L99.1185 148.329L99.7547 137.188L96.5335 139.269L95.7311 143.635L96.9137 151.02Z",
    fill: "#46FEF5",
    fillOpacity: 0.02
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_14933_19520",
    x: 46.9636,
    y: 81.0039,
    width: 22.3865,
    height: 54.9683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.71918
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_14933_19520",
    x: 29.9475,
    y: 69.7129,
    width: 23.4368,
    height: 19.1748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.98652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_14933_19520",
    x: 50.2195,
    y: 76.1543,
    width: 18.2246,
    height: 15.3838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.98652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_14933_19520",
    x: 43.53,
    y: 68.3667,
    width: 22.3826,
    height: 9.32275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.98652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_14933_19520",
    x: 34.7429,
    y: 88.9185,
    width: 30.8369,
    height: 47.9458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.98652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_14933_19520",
    x: 28.8291,
    y: 85.3867,
    width: 18.1104,
    height: 7.8877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.98652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_14933_19520",
    x: 28.9248,
    y: 92.1562,
    width: 32.3938,
    height: 44.7202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.98652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_14933_19520",
    x: 65.5798,
    y: 90.3721,
    width: 9.15796,
    height: 45.7256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.98652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_14933_19520",
    x: 66.4968,
    y: 80.8853,
    width: 8.24731,
    height: 15.0059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.98652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_14933_19520",
    x: 121.526,
    y: 64.353,
    width: 9.4812,
    height: 6.6958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.74161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_14933_19520",
    x: 108.285,
    y: 58.0933,
    width: 9.46753,
    height: 4.61084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.74161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_14933_19520",
    x: 114.826,
    y: 54.8989,
    width: 30.7922,
    height: 9.06641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.74161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_14933_19520",
    x: 127.198,
    y: 56.6069,
    width: 19.5957,
    height: 29.4731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5646
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_14933_19520",
    x: 94.6418,
    y: 62.9663,
    width: 33.7034,
    height: 38.9741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.4727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_14933_19520",
    x: 101.302,
    y: 82.3232,
    width: 32.3845,
    height: 19.6045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.17605
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_14933_19520",
    x: 125.044,
    y: 85.2354,
    width: 21.614,
    height: 14.4092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.74161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_14933_19520",
    x: 76.0881,
    y: 120.206,
    width: 10.6997,
    height: 17.6694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_14933_19520",
    x: 85.3833,
    y: 129.357,
    width: 11.428,
    height: 17.7354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_14933_19520",
    x: 78.9744,
    y: 111.042,
    width: 12.302,
    height: 18.2158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_14933_19520",
    x: 86.7024,
    y: 122.183,
    width: 12.3237,
    height: 10.3843,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_i_14933_19520",
    x: 90.5466,
    y: 113.689,
    width: 4.50464,
    height: 8.46338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_i_14933_19520",
    x: 90.6545,
    y: 118.286,
    width: 8.49048,
    height: 10.7534,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_i_14933_19520",
    x: 76.0044,
    y: 130.548,
    width: 12.4077,
    height: 17.2368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_i_14933_19520",
    x: 88.3152,
    y: 144.133,
    width: 7.11987,
    height: 9.43457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_i_14933_19520",
    x: 84.2922,
    y: 144.199,
    width: 8.37329,
    height: 9.24268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_i_14933_19520",
    x: 93.0708,
    y: 143.684,
    width: 3.92603,
    height: 9.8125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_i_14933_19520",
    x: 95.9329,
    y: 128.387,
    width: 3.50317,
    height: 10.9038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_i_14933_19520",
    x: 96.8113,
    y: 136.625,
    width: 2.99341,
    height: 2.66553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_i_14933_19520",
    x: 95.731,
    y: 137.188,
    width: 4.02368,
    height: 13.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.996078 0 0 0 0 0.96 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14933_19520"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14933_19520",
    x1: 70.1239,
    y1: 87.7839,
    x2: 58.3696,
    y2: 125.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46FEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FE93",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14933_19520",
    x1: 57.0215,
    y1: 96.2526,
    x2: 66.6012,
    y2: 139.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4675FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46E2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14933_19520",
    x1: 57.856,
    y1: 115.564,
    x2: 40.3268,
    y2: 78.7373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47FE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FE93",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14933_19520",
    x1: 78.0361,
    y1: 76.7462,
    x2: 33.4766,
    y2: 77.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46FEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46FEF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14933_19520",
    x1: 66.6883,
    y1: 95.8183,
    x2: 50.7085,
    y2: 66.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4675FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14933_19520",
    x1: 56.4821,
    y1: 85.2357,
    x2: 42.8616,
    y2: 64.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46FEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FE93",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14933_19520",
    x1: 82.2118,
    y1: 149.452,
    x2: 54.8583,
    y2: 108.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4675FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14933_19520",
    x1: 40.8736,
    y1: 70.5065,
    x2: 54.8791,
    y2: 108.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46FEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46FEF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14933_19520",
    x1: 40.7703,
    y1: 96.1816,
    x2: 25.6361,
    y2: 88.2631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46FEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46FEF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14933_19520",
    x1: 66.294,
    y1: 154.044,
    x2: 28.9309,
    y2: 109.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46FEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FE93",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14933_19520",
    x1: 69.6406,
    y1: 135.356,
    x2: 71.8986,
    y2: 105.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4675FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14933_19520",
    x1: 67.9129,
    y1: 92.4554,
    x2: 73.4542,
    y2: 86.5564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46FEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46FEF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14933_19520",
    x1: 136.766,
    y1: 88.5462,
    x2: 151.129,
    y2: 66.9769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46FEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FE93",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14933_19520",
    x1: 174.809,
    y1: 71.9835,
    x2: 107.956,
    y2: 90.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EF9C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14933_19520",
    x1: 75.9024,
    y1: 133.952,
    x2: 103.214,
    y2: 75.0746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4675FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14933_19520",
    x1: 148.556,
    y1: 72.9464,
    x2: 115.199,
    y2: 103.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46FEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46FEF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14933_19520",
    x1: 87.6028,
    y1: 123.773,
    x2: 124.842,
    y2: 94.9161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4675FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14933_19520",
    x1: 154.83,
    y1: 64.6305,
    x2: 133.936,
    y2: 102.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EF9C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14933_19520",
    x1: 95.2814,
    y1: 155.58,
    x2: 90.5165,
    y2: 136.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EF9C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_14933_19520",
    x1: 89.2163,
    y1: 119.043,
    x2: 84.0773,
    y2: 125.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64FFB1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_14933_19520",
    x1: 91.184,
    y1: 132.64,
    x2: 91.6289,
    y2: 125.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47FE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FED3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_14933_19520",
    x1: 92.6939,
    y1: 121.765,
    x2: 98.9668,
    y2: 122.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47FED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FED3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_14933_19520",
    x1: 84.4994,
    y1: 142.072,
    x2: 103.669,
    y2: 145.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4675FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46E2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_14933_19520",
    x1: 91.2889,
    y1: 144.019,
    x2: 88.0902,
    y2: 149.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EFF12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_14933_19520",
    x1: 99.6773,
    y1: 149.671,
    x2: 95.3433,
    y2: 142.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EFF12",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EF9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudgment);
export default __webpack_public_path__ + "static/media/Judgment.cdbb803b6f639d070c8a6356224d4af8.svg";
export { ForwardRef as ReactComponent };